export enum TooltipPosition {
  AUTOMATIC = 'AUTOMATIC',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}
